// import { formatDate } from "../helpers";
import formatDate from "../../../utils/holidayDateFormatter";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import IconRoundButton from "../../_utils/CommonButtons/IconRoundButton";
import SvgComponent from "../../_utils/SVGComponent";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
import ICONS from "../../../assets/Icons";
import TEXT from "../../../utils/globalText";
import { specificNotification } from "../../../redux/features/Notifications";
import Loader from "../../Loader/Index";

// turns 1 into 1st, 2 into 2nd, 3 into 3rd and so on and so forth

export default function ChannelsOccurencePopup({ closeCallback, id }) {
  const [animate, setAnimate] = useState(false);
  const dispatch = useDispatch();
  const [occurenceLoading, setOccurenceLoading] = useState(true);
  const [occurrences, setOccurences] = useState([]);

  const fetchData = async () => {
    try {
      const response = await dispatch(specificNotification({ id }));

      if (response?.payload?.status) {
        setTimeout(() => {
          setOccurenceLoading(false);
        }, IntervalConfiguration.intervalExtraLarge);

        setOccurences(response?.payload?.target_channels || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const mapChannelIcon = (channelProvider) => {
    let data = [
      { icon: ICONS.GOOGLE_CHAT, provider: "gchat" },
      { icon: ICONS.MICROSOFT_TEAMS, provider: "teams" },
      { icon: ICONS.WEB_HOOK, provider: "generic" },
      { icon: ICONS.SLACK, provider: "slack" },
    ]?.filter((item) => item.provider.toLowerCase().includes(channelProvider));
    return data[0]?.icon;
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const occrs = occurrences;

  const tableRows = occrs?.map((channel, e) => {
    return (
      <div
        className={`flex flex-row justify-between w-full items-center text-text-primary text-font-sm text-center py-padding-sm ${
          e === occurrences.length - GlobalConfiguration.lengthCheckOne
            ? "border-none"
            : "border-b border-primary-nav"
        }`}
        key={e}
      >
        <div className="w-width-full text-text-primary text-font-sm">
          <p className="break-all">
            {channel?.name?.charAt(0).toUpperCase() +
              channel?.name?.slice(1, channel?.name.length)}
          </p>
        </div>
        <div className="w-width-full flex justify-center">
          <img
            className="h-icon-md w-icon-md"
            src={mapChannelIcon(channel?.provider)}
            alt=""
          />
        </div>
      </div>
    );
  });
  return (
    <>
      <div className="fixed left-left-base top-top-base w-width-full h-height-full z-z-index-modal bg-PopUp-BackDrop opacity-dark-opacity" />
      <div className="fixed left-left-base top-top-base w-width-full h-height-full z-z-index-max">
        <div className="flex Qmd:flex-col w-width-full h-height-full justify-center items-center Qmd:gap-gap-xl">
          <div
            className={` w-standard-largePopup-width Qmd:w-small-popup-width  max-h-alert-popup-height-1 xxl:max-h-alert-popup-height-2 tall:max-h-alert-popup-height-2 ${occurenceLoading || occurrences.length === GlobalConfiguration.lengthCheckZero ? "h-[var(--notification-popup-height)]" : "h-auto"} w-full Qmd:w-small-popup-width flex flex-col  bg-primary-bg rounded-border-radius-md overflow-hidden animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"}`}
          >
            <div className="heading-section flex  Qmd:flex p-padding-md flex-row justify-between items-center Qmd:rounded-t-border-radius-md gap-gap-md ">
              <div className="flex flex-col gap-1">
                <p className="text-text-primary text-font-md font-semibold">
                  Channels
                </p>
                <p className="text-text-secondary text-font-xs ">
                  Below are the channel name and source of the notification.
                </p>
              </div>

              <IconRoundButton
                enabledBgColor="var(--primary-nav)"
                isLoading={false}
                handleFunction={() => {
                  setAnimate(true);
                  setTimeout(() => {
                    closeCallback();
                  }, IntervalConfiguration.intervalSemiMid);
                }}
                icon={ICONS?.CLOSE}
                title={TEXT?.CLOSE}
                hoverOption="white"
              />
            </div>

            <div className="bg-primary-nav-act lg:bg-primary-nav flex justify-between w-width-full p-padding-xs shadow-box-shadow-bottom">
              <div className="text-center text-text-primary text-font-sm w-width-full border-r border-primary-bg">
                {"Channel name"}
              </div>
              <div className="text-center text-text-primary text-font-sm w-width-full">
                {"Target"}
              </div>
            </div>

            <div
              className={`flex  flex-col  justify-start Qmd:items-start items-center flex-1 ${occurenceLoading || occurrences.length === GlobalConfiguration.lengthCheckZero ? "Qmd:h-totp-graphic-height justify-center" : " Qmd:h-[fit-content]"}  Qmd:pb-padding-base  overflow-y-auto`}
            >
              {occurenceLoading ? (
                <div className="flex flex-col justify-center items-center mx-auto">
                  <Loader
                    height="var(--icon-lg)"
                    width="var(--icon-lg)"
                  />
                </div>
              ) : occurrences ? (
                <div className="  flex flex-col w-full  Qmd:w-width-full rounded-border-radius-sm Qmd:rounded-t-none items-center lg:px-padding-md  overflow-y-scroll px-padding-md ">
                  {tableRows}
                </div>
              ) : (
                <div className="flex flex-col justify-center items-center mx-auto text-text-primary">
                  <p>No data found</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
